'use client';

import { Collapse } from '@/uiComposites/interactive/Collapse';
import { useIsOpened } from '@/uiComposites/interactive/IsOpenedContext';
import { chevronIcon } from '@/uiIcons/chevronIcon.css';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { occupy } from '@/uiPrimitives/layout/occupy';
import { shelf } from '@/uiPrimitives/layout/shelf';
import { icon } from '@/uiPrimitives/media/icon';
import { textStyle } from '@/uiPrimitives/typography/text';
import { addTestSelector } from '@dop/shared/helpers/testSelector';
import { ReactNode } from 'react';

export const ParticipationInfoButton = ({
	children,
	className,
}: {
	children: ReactNode;
	className?: string;
}) => {
	const { isOpened, setIsOpened, id } = useIsOpened();

	return (
		<button
			className={classes(
				className,
				textStyle({
					color: 'positiveBlue',
					textDecorationLine: 'underline',
				}),
				shelf({
					columnGap: '0 | p',
				}),
			)}
			onClick={() => {
				setIsOpened((oldIsOpened) => !oldIsOpened);
			}}
			aria-expanded={isOpened}
			aria-controls={id}
			{...addTestSelector('uiParticipationInfoButton')}
		>
			{children}
			<span
				className={classes(occupy({ blockSize: 'capSize', alignItems: 'end' }))}
			>
				<i
					className={classes(
						icon({
							icon: chevronIcon,
							adjustIcon: 'rotate90deg',
							blockSize: '1ex',
							flip: isOpened ? 'horizontal' : undefined,
						}),
					)}
				/>
			</span>
		</button>
	);
};

export const ParticipationInfo = ({ children }: { children: ReactNode }) => {
	const { isOpened, id } = useIsOpened();

	return (
		<Collapse
			isOpened={isOpened}
			id={id}
			{...addTestSelector('uiMoreInfoText')}
		>
			{children}
		</Collapse>
	);
};
